import React, { PureComponent, Fragment } from "react";
import { string, array, object, func } from "prop-types";
import axios from "axios";
import util from "../../../util";
import toastr from "toastr";

import CartItemGroup from "./CartItemGroup";
import CartItem from "./CartItem";
import OrderSummary from "./OrderSummary";
import OrderSummaryItem from "./OrderSummaryItem";
import Button from "../Components/Button";

class Checkout extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            sellers: props.initialSellers,
            cart: props.initialCart,
            totals: props.initialTotals,
            checkoutUrl: "",
            isLoading: false
        };

        this.fetchCart = this.fetchCart.bind(this);
        this.fetchProducts = this.fetchProducts.bind(this);
        this.fetchSellers = this.fetchSellers.bind(this);
        this.handleRemoveItem = this.handleRemoveItem.bind(this);
        this.handleQtyChange = this.handleQtyChange.bind(this);
        this.getProductsWithoutSellers = this.getProductsWithoutSellers.bind(
            this
        );
        this.pushRemoveCartToDataLayer = this.pushRemoveCartToDataLayer.bind(this);
        this.proceedToCheckout = this.proceedToCheckout.bind(this);
    }

    componentDidMount() {
        axios
            .get("/api/customers/get-checkout-url")
            .then(result => {
                this.setState({
                    checkoutUrl: result.data
                });
            })
            .catch(err => {
                console.error(err);
            });
    }

    fetchCart() {
        Promise.all([axios.get("/cart"), axios.get("/cart/totals")])
            .then(([cartResult, totalsResult]) => {
                if (cartResult.data.items.length > 0) {
                    let skus = cartResult.data.items.map(item => {
                        return item.sku;
                    });

                    let filterGroups = [
                        {
                            field: "sku",
                            value: skus.join(","),
                            condition: "in"
                        },
                        {
                            field: "type_id",
                            value: "virtual,simple",
                            condition: "in"
                        }
                    ];

                    this.fetchProducts(filterGroups, cartResult, totalsResult);
                } else {
                    this.setState({
                        cart: cartResult.data,
                        sellers: [],
                        totals: []
                    });
                    this.props.didFetch;
                }
            })
            .catch(err => {
                console.error(err);
            });
    }

    fetchProducts(filterGroups, cartResult, totalsResult) {
        axios
            .get(`/api/products?filterGroups=${JSON.stringify(filterGroups)}`)
            .then(productsResult => {
                let sellers = [];

                productsResult.data.items.forEach(product => {
                    let processedProduct = util.processCustomAttributes(
                        product
                    );

                    let seller_id = Number(processedProduct.seller_id);

                    if (!sellers.includes(Number(seller_id))) {
                        sellers.push(Number(seller_id));
                    }

                    let cartItemIndex = cartResult.data.items.findIndex(
                        cartItem => {
                            return cartItem.sku == processedProduct.sku;
                        }
                    );

                    cartResult.data.items[
                        cartItemIndex
                    ].product_attributes = processedProduct;
                });

                let sellerPromises = sellers.map(seller => {
                    return axios.get(`/api/sellers/${seller}/shop`);
                });

                this.fetchSellers(sellerPromises, cartResult, totalsResult);
            })
            .catch(err => {
                console.error(err);
            });
    }

    fetchSellers(sellerPromises, cartResult, totalsResult) {
        Promise.all(sellerPromises)
            .then(sellerResults => {
                let sellers = sellerResults.map(currentSeller => {
                    return currentSeller.data;
                });

                this.setState({
                    sellers: sellers,
                    cart: cartResult.data,
                    totals: totalsResult.data.total_segments,
                    isLoading: false
                });
            })
            .catch(err => {
                console.error(err);
            });
    }

    getProductsWithoutSellers() {
        return this.state.cart.items.reduce((acc, item) => {
            if (
                !item.product_attributes ||
                !item.product_attributes.seller_id
            ) {
                acc.push(
                    <CartItem
                        readOnly={true}
                        key={item.sku}
                        removeItem={this.handleRemoveItem}
                        qtyChange={this.handleQtyChange}
                        {...item}
                    />
                );
            }
            return acc;
        }, []);
    }

    pushRemoveCartToDataLayer(itemId){
        const itemToRemove = this.state.cart.items.find(item => item.item_id == itemId);

        if(window.dataLayer && itemToRemove){
            const pushEvent = {
                event: "removeFromCart",
                ecommerce: {
                    remove: {
                        products: [{
                            name: itemToRemove.name,
                            id: itemToRemove.item_id,
                            price: itemToRemove.price,
                            brand: itemToRemove.product_attributes.manufacturer_name,
                            seller_id: itemToRemove.product_attributes.seller_id,
                            adNo: itemToRemove.sku,
                            quantity: itemToRemove.qty
                        }]
                    }
                }
            };

            window.dataLayer.push(pushEvent);
        }
    }

    proceedToCheckout(){
        if(this.state.cart.items && this.state.cart.items.length > 0){
            if(window.dataLayer){
                const products = this.state.cart.items.map(item => {
                    return {
                        name: item.name,
                        id: item.item_id,
                        price: item.price,
                        brand: item.product_attributes.manufacturer_name,
                        seller_id: item.product_attributes.seller_id,
                        adNo: item.sku,
                        quantity: item.qty
                    };
                });
                const pushEvent = {
                    event: "checkout",
                    ecommerce: {
                        actionField: { step: 1 },
                        checkout: {
                            products: products
                        }
                    }
                };

                window.dataLayer.push(pushEvent, () => document.location = this.state.checkoutUrl);
            } else {
                document.location = this.state.checkoutUrl;
            }
        }
    }

    render() {
        if (this.state.cart.items.length > 0) {
            const sellerlessProducts = this.getProductsWithoutSellers();

            return (
                <Fragment>
                    <div className="row">
                        <div className="col-12">
                            <h2 className="title">Shopping Cart</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-8 col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <Fragment>
                                        {this.state.sellers.map(seller => {
                                            return (
                                                <CartItemGroup
                                                    key={seller.seller_id}
                                                    title={seller.shop_title}
                                                    logo={seller.logo_pic}>
                                                    {this.state.cart.items.map(
                                                        (item, index) => {
                                                            if (
                                                                item.product_attributes &&
                                                                item
                                                                    .product_attributes
                                                                    .seller_id ==
                                                                    seller.seller_id
                                                            ) {
                                                                return (
                                                                    <CartItem
                                                                        key={`${index}-${
                                                                            item.sku
                                                                        }`}
                                                                        removeItem={
                                                                            this
                                                                                .handleRemoveItem
                                                                        }
                                                                        qtyChange={
                                                                            this
                                                                                .handleQtyChange
                                                                        }
                                                                        {...item}
                                                                    />
                                                                );
                                                            }
                                                        }
                                                    )}
                                                </CartItemGroup>
                                            );
                                        })}
                                    </Fragment>
                                    {sellerlessProducts &&
                                        sellerlessProducts.length > 0 && (
                                        <Fragment>
                                            <CartItemGroup
                                                key={"no-seller-grouping"}>
                                                {sellerlessProducts}
                                            </CartItemGroup>
                                        </Fragment>
                                    )}
                                </div>
                                <div className="card-footer">
                                    <a
                                        className="btn btn-block btn-outline-lx"
                                        href="/">
                                        Continue Shopping
                                    </a>
                                </div>
                                {this.state.isLoading && (
                                    <div className="lmask" />
                                )}
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 OrderSummaryContainer">
                            <div className="card">
                                <div className="card-body">
                                    <OrderSummary title="Order Summary">
                                        {this.state.totals.map(item => {
                                            return (
                                                <OrderSummaryItem
                                                    key={item.code}
                                                    details={item}
                                                />
                                            );
                                        })}
                                    </OrderSummary>
                                </div>
                                <div className="card-footer flex-column text-center">
                                    <Button
                                        className="btn btn-block btn-lx"
                                        label="Proceed to Checkout"
                                        onClick={() => this.proceedToCheckout()}
                                        icon="far fa-arrow-alt-right"
                                        iconPosition="right"
                                    />
                                </div>
                                {this.state.isLoading && (
                                    <div className="lmask" />
                                )}
                            </div>
                            <div className="text-center">
                                <small>
                                    <em>
                                        Proceeding to Checkout will direct you
                                        to checkout.labx.com
                                    </em>
                                </small>
                            </div>
                        </div>
                    </div>
                </Fragment>
            );
        } else {
            return (
                <div className="row">
                    <div className="col-12 text-center">
                        <h1 className="title main">Shopping Cart</h1>
                        <h2 style={{ padding: "3rem 0 3rem 0" }}>
                            There are no items in your cart
                        </h2>
                    </div>
                </div>
            );
        }
    }

    handleRemoveItem(itemId) {
        this.pushRemoveCartToDataLayer(itemId);
        this.setState(
            {
                isLoading: true
            },
            () => {
                axios
                    .delete(`/cart/${itemId}`)
                    .then(() => {
                        this.fetchCart();
                    })
                    .catch(err => {
                        console.error(err);
                    });
            }
        );
    }

    handleQtyChange(itemId, newQty) {
        this.setState(
            {
                isLoading: true
            },
            () => {
                axios
                    .put(`/cart/${itemId}`, newQty)
                    .then(() => {
                        this.fetchCart();
                    })
                    .catch(err => {
                        /*this.setState({
                    isLoading: false
                });*/
                        this.fetchCart();
                        toastr.error(err.response.data);
                    });
            }
        );
    }
}

Checkout.propTypes = {
    initialCart: object.isRequired,
    initialTotals: array.isRequired,
    initialSellers: array.isRequired,
    isCustomer: string,
    didFetch: func
};

export { Checkout };
